import * as React from 'react';
import cn from 'classnames';
import Step from './Step/Step';
import { useTheme } from '../../../theme';
import { useAvailableSteps } from '../hooks';
import Money from '../../../Money';
import { capitalizeFirstLetter } from '../../../utils';
import { CdnIcon } from '@shared/ui';
import { STEP_ICON_NAME_BY_TYPE } from '../Icons';
const Stepbar = ({ steps, activeStep, onCartClick, totalPrice, additional, content, renderAdditionalStep, className, variant = 'default' }) => {
    const { Stepbar: css } = useTheme('Stepbar');
    const { availableSteps, currentAvailableStepIndex } = useAvailableSteps(steps, activeStep);
    const stepsArray = [];
    for (const key in availableSteps) {
        if (availableSteps.hasOwnProperty(key)) {
            stepsArray.push(Object.assign(Object.assign({}, availableSteps[key]), { icon: React.createElement(CdnIcon, { icon: STEP_ICON_NAME_BY_TYPE[capitalizeFirstLetter(key)] }) }));
        }
    }
    return (React.createElement("div", { className: cn(className, css.stepbar) },
        React.createElement("div", { className: css.inner },
            React.createElement("div", { className: css.content },
                additional, content !== null && content !== void 0 ? content : (React.createElement(React.Fragment, null,
                stepsArray
                    .filter(step => !step.isHidden)
                    .map((step, index) => (React.createElement(Step, { key: index, id: index + 1, step: step, "data-step": step.type, isPassed: index < currentAvailableStepIndex, isActive: index === currentAvailableStepIndex, isDisabled: step.isDisabled, variant: variant }))),
                renderAdditionalStep && renderAdditionalStep()))),
            onCartClick && (React.createElement("div", { onClick: onCartClick, className: css.cart },
                React.createElement(CdnIcon, { icon: "Navigation/Shopping Cart" }),
                React.createElement(Money, { money: totalPrice }),
                React.createElement(CdnIcon, { icon: "Arrow/Chevron_right" }))))));
};
export default Stepbar;
